<template>
  <v-container fluid>
    <v-layout wrap class="mb-3">
      <v-autocomplete v-model="customerFilter" :items="customerList" label="Select a Customer" item-text="name"
        hide-details item-value="key" clearable>
      </v-autocomplete>
    </v-layout>
    <v-alert
      :value="!customerFilter"
      type="info"
    >
      Please Select a Customer
    </v-alert>
    <v-card v-if="customerFilter">
    <v-card-title>
      <v-btn color="primary" @click="exportData">Export</v-btn>
      <v-autocomplete
        v-model="vehicleFilter"
        label="Filter Vehicles"
        multiple
        item-text="VehicleReg"
        item-value="key"
        :items="vehicles"
        hide-details
        chips
        deletable-chips
        single-line
        clearable
        solo
      ></v-autocomplete>
      <v-spacer></v-spacer>
      <v-autocomplete
        v-model="productFilter"
        label="Filter Products"
        item-text="name"
        item-value="id"
        :items="productTypes"
        hide-details
        single-line
        clearable
        solo
      ></v-autocomplete>
      <v-spacer></v-spacer>
      <v-text-field
        v-model="search"
        append-icon="search"
        label="Search"
        single-line
        hide-details
      ></v-text-field>
    </v-card-title>
    <v-alert
      v-model="exportAlert"
      type="success"
      dismissible
    >
      Data copied to clipboard
    </v-alert>
    <v-data-table
      :headers="headers"
      :items="products"
      class="elevation-1"
      :search= "search"
    >
      <template slot="items" slot-scope="props">
        <tr @click="props.expanded = !props.expanded">
          <td>{{ props.item.type }}</td>
          <td>{{ props.item.vehReg }}</td>
          <td style="text-transform: capitalize;">{{ props.item.warrantyType }}</td>
          <td :class="{error: props.item.warrantyExpired}">{{ props.item.warrantyExpiry }}</td>
          <td :class="{error: props.item.contractExpired}">{{ props.item.contractExpiry }}</td>
        </tr>
      </template>
      <template v-slot:expand="props">
          <v-layout justify-center>
            <v-card flat>
              <ul style="list-style-type: none;">
                <li>Contract Start: {{props.item.installDate | formatDate}}</li>
                <li>Contract Term: {{props.item.contractLength}} {{props.item.contractPeriod}}</li>
                <li>Contract Expiry: {{props.item.contractExpiry}}</li>
                <li>Warranty Period: {{props.item.warrantyLength}} {{props.item.warrantyPeriod}}</li>
                <li style="text-transform: capitalize">Warranty Type: {{props.item.warrantyType}}</li>
                <li>Upfront Amount: {{props.item.currency === 'gbp' ? '£' : '€'}}{{props.item.upfrontPayment || '-'}}</li>
                <li>Upfront Installation: {{props.item.currency === 'gbp' ? '£' : '€'}}{{props.item.installationPayment || '-'}}</li>
                <li>Rental Frequency: {{props.item.rentalFrequency || '-'}}</li>
                <li>Rental Amount: {{props.item.currency === 'gbp' ? '£' : '€'}}{{props.item.rentalPayment || '-'}}</li>
                <li>Lease Frequency: {{props.item.leaseFrequency || '-'}}</li>
                <li>Lease Amount: {{props.item.currency === 'gbp' ? '£' : '€'}}{{props.item.leasePayment || '-'}}</li>
                <li>Installation Date: {{props.item.installDate | formatDate}}</li>
                <li>Project: {{props.item.project}}</li>
                <li>Job: <v-btn small :to="{path: '/Project/'+customerFilter+'/'+props.item.job}" flat>View Job</v-btn></li>
                <li><v-btn small @click="viewDevice(props.item)" flat>View Devices</v-btn></li>
              </ul>
            </v-card>
          </v-layout>
        </template>
    </v-data-table>
    </v-card>
    <textarea id="exportData" hidden></textarea>
  </v-container>
</template>
<script>
// import { fireStore } from '../firebase'
import moment from 'moment'
export default {
  props: ['customer', 'product', 'vehicle'],
  data () {
    return {
      vehicleFilter: this.vehicle ? [this.vehicle] : [],
      productFilter: this.product ? this.product : null,
      exportAlert: false,
      headers: [
        {
          text: 'Product Type',
          value: 'type'
        },
        {
          text: 'Vehicle',
          value: 'vehReg'
        },
        {
          text: 'Warranty Type',
          value: 'warrantyType'
        },
        {
          text: 'Warranty Expiry',
          value: 'warrantyExpiry'
        },
        {
          text: 'Contract Expiry',
          value: 'contractExpiry'
        }
      ],
      search: '',
      customerFilter: this.customer ? this.customer : null
    }
  },
  created () {
    this.$store.dispatch('fetchCustomers')
    this.$store.dispatch('fetchVehicles')
    this.$store.dispatch('fetchProductTypes')
  },
  filters: {
    formatDate (val) {
      return val !== undefined && val !== null ? moment(val).format('DD/MM/YYYY') : null
    }
  },
  methods: {
    viewDevice (item) {
      this.$router.push({path: '/Devices/' + this.customerFilter + '/' + item.vehicleKey})
    },
    exportData () {
      let extraFields = [
        { text: 'Contract Start', value: 'installDate' },
        { text: 'Contract Term', value: 'contractTerm' },
        { text: 'Warranty Period', value: 'warranty' },
        { text: 'Warranty Type', value: 'warrantyType' },
        { text: 'Currency', value: 'currency' },
        { text: 'Upfront Amount', value: 'upfrontPayment' },
        { text: 'Upfront Installation', value: 'installationPayment' },
        { text: 'Rental Frequency', value: 'rentalFrequency' },
        { text: 'Rental Amount', value: 'rentalPayment' },
        { text: 'Lease Frequency', value: 'leaseFrequency' },
        { text: 'Lease Amount', value: 'leasePayment' },
        { text: 'Installation Date', value: 'installDate' },
        { text: 'Project', value: 'project' },
        { text: 'JobLink', value: 'linkJob' },
        { text: 'Device Link', value: 'linkDevice' }
      ]
      let data = ''
      for (let column of this.headers) {
        data += column.text + '\t'
      }
      for (let column of extraFields) {
        data += column.text + '\t'
      }
      data += '\n'
      for (let product of this.products) {
        for (let column of this.headers) {
          data += (product[column.value] || '') + '\t'
        }
        for (let column of extraFields) {
          if (column.value === 'linkJob') {
            data += ('=hyperlink("https://nexus.mycubo.online/#/Project/' + this.customerFilter + '/' + product.job + '")' || '') + '\t'
          } else if (column.value === 'linkDevice') {
            data += ('=hyperlink("https://nexus.mycubo.online/#/Devices/' + this.customerFilter + '/' + product.vehicleKey + '")' || '') + '\t'
          } else {
            data += (product[column.value] || '') + '\t'
          }
        }
        data += '\n'
      }
      console.log(data)
      document.getElementById('exportData').value = data
      document.getElementById('exportData').removeAttribute('hidden')
      setTimeout(() => {
        document.getElementById('exportData').select()
        document.execCommand('copy')
      }, 20)
      setTimeout(() => {
        document.getElementById('exportData').setAttribute('hidden', true)
        document.getElementById('exportData').value = ''
        this.exportAlert = true
      }, 40)
    }
  },
  computed: {
    productTypes () {
      return this.$store.getters.productTypes
    },
    customerList () {
      return this.$store.getters.customers
    },
    vehicles () {
      let vehicles = []
      for (let vehicle of this.$store.getters.vehicles) {
        if (vehicle.Customer !== this.customerFilter) {
          continue
        }
        vehicles.push(vehicle)
      }
      return vehicles
    },
    products () {
      let products = []
      let i = 0
      for (let vehicle of this.vehicles) {
        if (vehicle.Customer !== this.customerFilter || !vehicle.installedDevices) {
          continue
        }
        for (let product in vehicle.installedDevices) {
          if (this.productFilter && this.productFilter !== product) {
            continue
          }
          if (this.vehicleFilter && this.vehicleFilter.length > 0 && this.vehicleFilter.indexOf(vehicle.key) === -1) {
            continue
          }
          if (typeof vehicle.installedDevices[product] === 'object') {
            let thisProduct = vehicle.installedDevices[product]
            if (!this.productTypes.find(p => p.id === product)) {
              continue
            }
            console.log(thisProduct)
            thisProduct.key = product
            thisProduct.id = i
            thisProduct.type = this.productTypes.find(p => p.id === product).name
            thisProduct.vehReg = vehicle.VehicleReg
            thisProduct.vehicleKey = vehicle.key
            let warranty = thisProduct.warranty
            if (warranty) {
              if (warranty.indexOf('days') !== -1) {
                thisProduct.warrantyPeriod = 'days'
                thisProduct.warrantyLength = warranty.replace(/\D/g, '')
                thisProduct.warrantyExpiry = thisProduct.installDate ? moment(thisProduct.installDate).add(thisProduct.warrantyLength, thisProduct.warrantyPeriod).format('DD/MM/YYYY') : 'N/A'
                thisProduct.warrantyExpired = thisProduct.installDate ? moment().diff(moment(thisProduct.warrantyExpiry, 'DD/MM/YYYY'), 'days') > 0 : false
              } else if (warranty.indexOf('months') !== -1) {
                thisProduct.warrantyPeriod = 'months'
                thisProduct.warrantyLength = warranty.replace(/\D/g, '')
                thisProduct.warrantyExpiry = thisProduct.installDate ? moment(thisProduct.installDate).add(thisProduct.warrantyLength, thisProduct.warrantyPeriod).format('DD/MM/YYYY') : 'N/A'
                thisProduct.warrantyExpired = thisProduct.installDate ? moment().diff(moment(thisProduct.warrantyExpiry, 'DD/MM/YYYY'), 'days') > 0 : false
              } else {
                thisProduct.warrantyPeriod = ''
                thisProduct.warrantyType = '-'
                thisProduct.warrantyLength = 'N/A'
                thisProduct.warrantyExpiry = 'N/A'
                thisProduct.warrantyExpired = false
              }
            }
            let contractTerm = thisProduct.contractTerm
            if (contractTerm) {
              if (contractTerm.indexOf('days') !== -1) {
                thisProduct.contractPeriod = 'days'
                thisProduct.contractLength = contractTerm.replace(/\D/g, '')
                thisProduct.contractExpiry = thisProduct.installDate ? moment(thisProduct.installDate).add(thisProduct.contractLength, thisProduct.contractPeriod).format('DD/MM/YYYY') : 'N/A'
                thisProduct.contractExpired = moment().diff(moment(thisProduct.contractExpiry, 'DD/MM/YYYY'), 'days') > 0
              } else if (contractTerm.indexOf('months') !== -1) {
                thisProduct.contractPeriod = 'months'
                thisProduct.contractLength = contractTerm.replace(/\D/g, '')
                thisProduct.contractExpiry = thisProduct.installDate ? moment(thisProduct.installDate).add(thisProduct.contractLength, thisProduct.contractPeriod).format('DD/MM/YYYY') : 'N/A'
                thisProduct.contractExpired = moment().diff(moment(thisProduct.contractExpiry, 'DD/MM/YYYY'), 'days') > 0
              } else {
                thisProduct.contractPeriod = ''
                thisProduct.contractLength = 'N/A'
                thisProduct.contractExpiry = 'N/A'
                thisProduct.contractExpired = false
              }
            }
            products.push(vehicle.installedDevices[product])
            i++
          }
        }
      }
      return products
    }
  }
}
</script>


// WEBPACK FOOTER //
// Products.vue?2e6b25a1